import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import styles from './mixins.module.css';

/**
 * Superscript (used for the ® mark). Formerly a styled.sup; the rest of this
 * file's styled-components mixins (font @font-face, gridMixin, shimmer,
 * hideScrollbar, …) were removed in the CSS Modules migration — fonts are loaded
 * via next/font and the shared mixins became global utilities in styles/utilities.css.
 */
export const Sup = forwardRef<HTMLElement, ComponentPropsWithoutRef<'sup'>>(
  ({ className, ...rest }, ref) => (
    <sup
      ref={ref}
      className={className ? `${styles.sup} ${className}` : styles.sup}
      {...rest}
    />
  ),
);
Sup.displayName = 'Sup';
